import { NavigationProp, useNavigation } from "@react-navigation/native";
import { useMutation } from "@tanstack/react-query";
import BaseCard, { BaseCardListItem } from "components/BaseCard";
import MainContainer from "components/MainContainer";
import Spacer from "components/Spacer";
import Switch from "components/Switch";
import { useAccount } from "hooks/useAccount";
import { AccountStackParamList } from "navigation/types";
import i18n from "plugins/localization";
import { updateAccountFetcher } from "queries/account.queries";
import React, { useState } from "react";
import { View } from "react-native";

const Settings = () => {
  const navigation = useNavigation<NavigationProp<AccountStackParamList>>();
  const { account, updateFetchAccountBffCache } = useAccount();
  const { mutateAsync: updateAccount } = useMutation(updateAccountFetcher);
  const [includeAccessibleToggle, setIncludeAccessibleToggle] = useState(
    account?.seatPreference === "INCLUDE_ACCESSIBLE",
  );

  const [emailConsent, setEmailConsent] = useState(
    account?.emailMarketingConsent ?? false,
  );
  const [smsConsent, setSmsConsent] = useState(
    account?.smsMarketingConsent ?? false,
  );

  const handleIncludeAccessible = async (value: boolean) => {
    if (!account) return;
    setIncludeAccessibleToggle(value);
    const updated = await updateAccount({
      ...account,
      seatPreference:
        account!.seatPreference === "NONE" ? "INCLUDE_ACCESSIBLE" : "NONE",
    });
    updateFetchAccountBffCache(updated);
  };

  const handleEmailConsentChange = async (checked: boolean) => {
    if (!account) return;

    setEmailConsent(checked);
    const updated = await updateAccount({
      ...account,
      emailMarketingConsent: checked,
    });
    updateFetchAccountBffCache(updated);
  };

  const handleSmsConsentChange = async (checked: boolean) => {
    if (!account) return;
    setSmsConsent(checked);
    const updated = await updateAccount({
      ...account,
      smsMarketingConsent: checked,
    });
    updateFetchAccountBffCache(updated);
  };

  if (!account) return null;

  return (
    <MainContainer
      goBackAction={() => navigation.navigate("AccountScreen")}
      title={i18n.t("screens.Settings.settings")}
      grayBackground
    >
      <View style={{ padding: 15 }}>
        <BaseCard title={i18n.t("screens.Settings.settings")}>
          <BaseCardListItem
            title={i18n.t("screens.Settings.includeAccessible")}
            description={i18n.t(
              "screens.Settings.includeAccessibleDescription",
            )}
            accessoryRight={
              <Switch
                testID="include-accessible-switch"
                checked={includeAccessibleToggle}
                onChange={handleIncludeAccessible}
              />
            }
            onPress={() => handleIncludeAccessible(!includeAccessibleToggle)}
          />
        </BaseCard>

        <Spacer />

        <BaseCard title="Marketing Preferences">
          <BaseCardListItem
            title="Email"
            accessoryRight={
              <Switch
                testID="email-consent-switch"
                checked={emailConsent}
                onChange={handleEmailConsentChange}
              />
            }
            onPress={() => handleEmailConsentChange(!emailConsent)}
          />
          <BaseCardListItem
            title="SMS/Text"
            accessoryRight={
              <Switch
                testID="sms-consent-switch"
                checked={smsConsent}
                onChange={handleSmsConsentChange}
              />
            }
            onPress={() => handleSmsConsentChange(!smsConsent)}
          />
        </BaseCard>

        {/* <BaseCard title={i18n.t("screens.Settings.language")}>
          <BaseCardListItem title={<LanguageSelector />} showArrow={false} />
        </BaseCard> */}
      </View>
    </MainContainer>
  );
};

export default Settings;
